import { useState } from 'react';
import { Spinner } from '../../../../../components/Spinner';
import { NumericFormat } from 'react-number-format';
import { useEnv } from '../../../../../context/env-context';
import { useAuth } from '../../../../../hooks/useAuth';
import { makeRequest } from '../../../../../utils/makeRequest';
import { toast } from 'react-toastify';
import Overlay from 'react-bootstrap/Overlay';
import Popover from 'react-bootstrap/Popover';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

function ConsumerPopoverBridgePointsForm({
  target,
  popoverOpen,
  handleToggle,
  consumerId,
  getBridgePointsTransactions,
  setPanelDataRefresh,
}) {
  const { apiOriginConsumer } = useEnv();
  const { getAccessTokenSilently } = useAuth();

  const [spinner, setSpinner] = useState(false);

  const [amount, setAmount] = useState(0);
  const [description, setDescription] = useState('');

  const close = () => {
    setAmount(0);
    setDescription('');
    handleToggle();
  };

  const createManualTransaction = async () => {
    setSpinner(true);
    const token = await getAccessTokenSilently();

    if (!token) {
      return;
    }

    const config = {
      token,
      url: `${apiOriginConsumer}/bridgepoints/transaction`,
      method: 'POST',
      data: JSON.stringify({ consumerId, desc: description, amount: Number(amount) }),
    };

    try {
      await makeRequest(config);

      setPanelDataRefresh(prev => ({ ...prev, consumer: true }));
      getBridgePointsTransactions();
      close();

      toast.success('Successful Transaction');
    } catch (error) {
      toast.error(error.message);
    } finally {
      setSpinner(false);
    }
  };

  return (
    <Overlay
      show={popoverOpen}
      target={target.current}
      placement="right"
      popperConfig={{ modifiers: [{ name: 'offset', options: { offset: [0, 0] } }] }}
    >
      {props => (
        <Popover {...props} className="custom-popover">
          <Popover.Body className="bo-common-popover-form-menu bo-w-220">
            <Spinner visible={spinner} size={36}>
              <Form.Label className="bo-common-popover-form-menu-label">Description:</Form.Label>
              <Form.Control
                type="text"
                className="bo-common-popover-form-menu-input"
                value={description}
                onChange={e => setDescription(e.target.value)}
              />
              <Form.Label className="bo-common-popover-form-menu-label">Amount:</Form.Label>
              <NumericFormat
                type="text"
                className="bo-common-popover-form-menu-input"
                value={amount}
                onChange={e => setAmount(Number(e.target.value))}
                customInput={Form.Control}
                decimalScale={0}
              />
              <div className="mt-3 d-flex justify-content-between">
                <Button
                  className="bo-common-button"
                  onClick={createManualTransaction}
                  disabled={!description}
                >
                  Create
                </Button>
                <Button className="bo-common-button" onClick={close}>
                  Cancel
                </Button>
              </div>
            </Spinner>
          </Popover.Body>
        </Popover>
      )}
    </Overlay>
  );
}

export default ConsumerPopoverBridgePointsForm;
